<template>
  <div class="v-toolbar-items">
      <slot/>
  </div>
</template>

<script>

export default {
  name: 'VToolbarItems',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VToolbar";
</style>
